import { log } from 'log';
import { EventEmitterService } from './eventEmitter.service';

export class WebSocketService extends EventEmitterService {
    socket = null;
    isReconnecting = false;
    responseTimeout = 200000;
    reconnectTimeout = 15000;

    constructor({ apiURL }) {
        super();
        this.apiURL = apiURL;
    }

    /**
     * public method
     * Creating socket connection
     * @returns void
     */
    createConnection = () => {
        if (this.socket) {
            return;
        }

        if (!this.apiURL) {
            log('error', 'WebSocket API URL is not configured');

            return;
        }

        this.socket = new WebSocket(this.apiURL);

        this.addSubscriptions();
    };

    /**
     * public method
     * Manual reconnecting
     * @returns void
     */
    reconnect = () => {
        if (this.socket) {
            this.socket.close();
        }

        return this.createConnection();
    };

    reconnectWithTimeout = () => {
        if (this.isReconnecting) {
            return;
        }

        this.isReconnecting = true;

        setTimeout(() => {
            this.isReconnecting = false;
            this.createConnection();
        }, this.reconnectTimeout);
    };

    addSubscriptions = () => {
        if (!this.socket) {
            return;
        }

        this.socket.addEventListener('open', this.handleOpen);
        this.socket.addEventListener('error', this.handleError);
        this.socket.addEventListener('close', this.handleClose);
        this.socket.addEventListener('message', this.handleMessage);
    };

    removeSubscriptions = () => {
        if (!this.socket) {
            return;
        }

        this.socket.removeEventListener('open', this.handleOpen);
        this.socket.removeEventListener('error', this.handleError);
        this.socket.removeEventListener('close', this.handleClose);
        this.socket.removeEventListener('message', this.handleMessage);
    };

    handleOpen = () => {
        const prevIsReconnecting = this.isReconnecting;

        this.isReconnecting = false;

        this.trigger('open');

        if (prevIsReconnecting) {
            this.trigger('reconnected');
        }
    };

    handleError = (event) => {
        this.removeSubscriptions();
        this.socket = null;

        this.trigger('error', event);

        this.reconnectWithTimeout();
    };

    handleClose = (event) => {
        this.removeSubscriptions();
        this.socket = null;

        this.trigger('close', event);

        this.reconnectWithTimeout();
    };

    send = (request) => {
        if (!this.isReconnecting) {
            this.socket.send(JSON.stringify(request));
        }
    };

    handleMessage = ({ data }) => {
        let response = data;

        if (!this.isRawMessage) {
            try {
                response = JSON.parse(data);
            } catch (e) {
                log('error', 'unable to parse WS message', data);
            }
        }

        this.trigger('message', response);
    };
}
